module.exports = __webpack_public_path__ + "img/brown-carpet-grass-10.1b4adc69.png";